<template lang="jade">
  span
    input.input-digit(type="text",
                      :value="value",
                      ref="digit.id",
                      v-on:click="clickDigit($event)",
                      v-on:keydown.prevent="changeCurrentPosition($event)",
                      v-on:keyup.prevent="changeCurrentDigit($event)",
                      :class="{recognizable: recognizable, loading: seending, wrong_preenchimento: wrongPreenchimento, \
                        blur: isToBlurDigit, [`InputDigit-${position[0]}-${position[1]}`]: true}",
                      :disabled="seendingSheet || !canEditCurrentSheet")
</template>

<script>
export default {
  props: ['digit', 'position', 'onChangeFocus'],
  inject: ['openDayJourney'],
  computed: {
    seendingSheet () {
      return this.$store.getters.seendingSheet
    },
    seending () {
      return this.$store.getters.seending(this.digit.id)
    },
    value () {
      const result = this.digit.user_predicted || this.digit.heuristic || this.digit.machine_predicted || ''
      return result === '*' || result === 'E' ? '' : result
    },
    recognizable () {
      if (this.digit.recognizable === null) {
        return false
      } else {
        return !this.digit.recognizable
      }
    },
    shiftPresshed () { return this.$store.getters.shiftPressed },
    ctrlPresshed () { return this.$store.getters.ctrlPressed },
    wrongPreenchimento () {
      const result = this.digit.user_predicted || this.digit.heuristic || this.digit.machine_predicted || ''
      return result === '*'
    },
    canEditCurrentSheet () {
      return this.$store.getters.canEditCurrentSheet
    },
    isToBlurDigit () {
      return !this.digit.verify && !(this.$store.getters.currentDigit.id === this.digit.id)
    },
    toVerify () {
      return !this.digit.user_predicted && this.digit.verify
    }
  },
  methods: {
    confirmRightState () {
      const posState = [this.$store.getters.currentDigit.position[0], this.$store.getters.currentDigit.position[1]]
      const posNow = [this.position[0], this.position[1]]
      if (posState[0] !== posNow[0] || posState[1] !== posNow[1]) {
        this.$store.commit('setCurrentDigitPosition', this.position)
      }
    },
    clickDigit ($event) {
      $event.target.select()
      this.$store.commit('setCurrentDigitPosition', this.position)
    },
    changeCurrentPosition (e) {
      const keys = ['ArrowRight', 'ArrowLeft', 'ArrowUp', 'ArrowDown', 'Enter', 'Tab', 'w', 'a', 's', 'd', ' ', 'j', 'J', 'Shift', 'Control', 'l']
      if (!((isNaN(e.key) || e.key === ' ') && keys.includes(e.key))) { return }

      if (e.key === 'Shift') {
        this.$store.commit('shiftPressed', true)
        return
      } else if (e.key === 'Control') {
        this.$store.commit('ctrlPressed', true)
        return
      }

      if (['d', 'arrowright'].includes(e.key.toLowerCase()) && this.position[1] === 15) {
        this.openDayJourney(this.position[0], 'search')
        e.preventDefault()
        e.stopPropagation()
        return
      } else if (e.key.toLowerCase() === 'j' && (e.shiftKey || e.ctrlKey)) {
        this.openDayJourney(this.position[0], e.ctrlKey ? 'modal' : 'search')
        e.preventDefault()
        e.stopPropagation()
        return
      }

      let newPos = [this.position[0], this.position[1] + 1]

      if (this.ctrlPresshed && e.key === 'l') {
        this.$store.commit('setCurrentDigitPosition', [this.position[0] + 1, 0])
        this.onChangeFocus(this.$store.getters.currentDigit.id, [this.position[0] + 1, 0])
        this.$store.dispatch('clearAllValuesRow', this.position[0])
        return
      } else if (e.key === 'ArrowRight' || e.key === 'Enter' || e.key === 'd' || e.key === ' ') {
        newPos = [this.position[0], this.position[1] + 1]
      } else if (e.key === 'ArrowLeft' || e.key === 'a') {
        newPos = [this.position[0], this.position[1] - 1]
      } else if (e.key === 'ArrowUp' || e.key === 'w') {
        newPos = [this.position[0] - 1, this.position[1]]
      } else if (e.key === 'ArrowDown' || e.key === 's') {
        newPos = [this.position[0] + 1, this.position[1]]
      } else if (e.key === 'Tab') {
        if (!this.shiftPresshed) {
          if (this.position[1] === 15) {
            newPos = [this.position[0] + 1, 0]
          } else {
            newPos = [this.position[0], 15]
          }
        } else {
          if (this.position[1] === 0) {
            newPos = [this.position[0] - 1, 15]
          } else {
            newPos = [this.position[0], 0]
          }
        }
      }
      this.$store.commit('setCurrentDigitPosition', this.parsePosition(newPos))
      this.onChangeFocus(this.$store.getters.currentDigit.id, this.parsePosition(newPos))
    },
    changeCurrentDigit (e) {
      if (e.shiftKey && e.key.toLowerCase() === 'a') {
        console.log('open autocomplete')
        this.$emit('focusAutoComplete')
        return
      }

      const keys = ['ArrowRight', 'ArrowLeft', 'ArrowUp', 'ArrowDown', 'Enter', 'Tab', 'w', 'a', 's', 'd', ' ', 'Control', 'A']
      if ((isNaN(e.key) || e.key === ' ' || e.key === 'Shift') && keys.includes(e.key)) { return }

      if (e.key === 'Shift') {
        this.$store.commit('shiftPressed', false)
        return
      } else if (e.key === 'Control') {
        this.$store.commit('ctrlPressed', false)
        return
      }

      let newPos = newPos = [this.position[0], this.position[1] + 1]
      let commit = {name: 'setCurrentDigitPosition', payload: this.parsePosition(newPos)}
      let action = {}

      if (!isNaN(e.key) && e.key !== ' ') {
        action = {name: 'altered',
          payload: {
            digit: {
              ...this.digit,
              user_predicted: e.key.toString()
            },
            position: this.position
          }
        }
      } else if (e.key === 'i' || e.key === 'q') {
        action = {
          name: 'altered',
          payload: {
            digit: {
              ...this.digit,
              user_predicted: this.digit.user_predicted === '*' ? null : this.digit.user_predicted,
              recognizable: this.recognizable
            },
            position: this.position
          }
        }
      } else if (e.key === 'p' || e.key === 'e') {
        action = {
          name: 'altered',
          payload: {
            digit: {
              ...this.digit,
              user_predicted: this.digit.user_predicted === '*' ? null : '*',
              recognizable: true
            },
            position: this.position
          }
        }
      } else if (e.key === 'x') {
        action = {name: 'cutError', payload: this.position[0].toString()}
      } else if (e.key === 'Delete' || e.key === 'Backspace') {
        action = {name: 'altered',
          payload: {
            digit: {
              ...this.digit,
              user_predicted: 'E',
              valid_selection: true
            },
            position: this.position
          }
        }
      }

      if (commit.name && commit.payload) {
        this.$store.commit(commit.name, commit.payload)
      }

      if (action.name && action.payload) {
        this.$store.dispatch(action.name, action.payload)
      }
      this.onChangeFocus(this.$store.getters.currentDigit.id, this.parsePosition(newPos))
    },
    parsePosition (pos) {
      if (pos[1] > 15) {
        return [pos[0], 0]
      } else if (pos[1] < 0) {
        return [pos[0], 15]
      } else if (pos[0] < 0) {
        return [this.$store.getters.currentSheetRows.length - 1, pos[1]]
      } else if (pos[0] > this.$store.getters.currentSheetRows.length - 1) {
        return [0, pos[1]]
      } else {
        return pos
      }
    },
    onRecognizableOrWrongWrite (op) {
      let commit = {}
      let action = {}
      let newPos = [this.position[0], this.position[1] + 1]

      if (op === 'p') {
        commit = {name: 'setCurrentDigitPosition', payload: this.parsePosition(newPos)}
        action = {
          name: 'altered',
          payload: {
            digit: {
              ...this.digit,
              user_predicted: '*',
              recognizable: true
            },
            position: this.position
          }
        }
      } else if (op === 'i') {
        commit = {name: 'setCurrentDigitPosition', payload: this.parsePosition(newPos)}
        action = {
          name: 'altered',
          payload: {
            digit: {
              ...this.digit,
              user_predicted: this.digit.user_predicted === '*' ? '' : this.digit.user_predicted,
              recognizable: this.recognizable
            },
            position: this.position
          }
        }
      }
      if (commit.name && commit.payload) {
        this.$store.commit(commit.name, commit.payload)
      }

      if (action.name && action.payload) {
        this.$store.dispatch(action.name, action.payload)
      }
      this.onChangeFocus(this.$store.getters.currentDigit.id, this.parsePosition(newPos))
    }
  }
}
</script>

<style scoped>
  .input-digit {
    outline: none;
    width: 100%;
    text-align: center;
    border: none;
    border-bottom: 3px solid rgb(200, 200, 200);
    font-size: 25px;
    color : transparent;
    text-shadow : 0 0 0 #000;
    background-color: transparent;
  }

  .input-digit:focus {
    border: none;
    border-bottom: 3px solid rgb(50, 200, 50);
    outline : none;
    opacity: 1 !important;
    box-shadow: none !important;
    transform: scale(0.95) !important;

    animation-name: on_focus;
    animation-duration: 0.3s;
    animation-fill-mode: forwards;
    animation-timing-function: ease-in-out;
  }

  ::selection {
    color: white;
    background: rgb(140, 140, 140);
  }
  ::-moz-selection {
    color: white;
    background: rgb(140, 140, 140);
  }

  .recognizable {
    border-bottom: 3px solid rgb(255, 203, 85);
  }

  .wrong_preenchimento {
    border-bottom: 3px solid #6ecbff;
  }

  .loading {
    color: gray;
    background-color: #ffffff;
    background-image: url("http://loadinggif.com/images/image-selection/3.gif");
    background-size: 15px 15px;
    background-position: center;
    background-repeat: no-repeat;
  }
</style>



// WEBPACK FOOTER //
// InputDigit.vue?476f89a0